import { combineReducers } from "redux";
import authReducer from "./auth";
import commonReducer from "./common";

const rootReducer = combineReducers({
  auth: authReducer,
  common: commonReducer
});

export default rootReducer;